import { FilterType } from 'components/Shared/Table'

export const columns = [
  {
    id: 'name',
    label: 'userGroups.table.name',
    path: 'name',
    sortable: true,
    filterType: FilterType.Text
  },
  {
    id: 'createdOn',
    label: 'userGroups.table.createdOn',
    path: 'createdOn',
    sortable: true,
    filterType: FilterType.DateRange,
    filterNames: ['createdOnGe', 'createdOnLe']
  }
]
